import mock from 'src/utils/mock';

mock.onGet('/publisher/category/all').reply(200, [
  {
    categoryId: '5b7cc17a-a524-4775-b3f0-f5747d9a5c72',
    categoryName: 'TestCategoryyy',
    catalogues: [],
    subCategories: [
      {
        subCategoryId: '929876c4-1a63-48e0-a444-cc9730f480c5',
        subCategoryName: 'Test Subcategory Updated',
        catalogues: [],
      },
      {
        subCategoryId: '17102d39-68e9-4ddc-8893-69bb6c02b147',
        subCategoryName: 'Test Subcategory3',
        catalogues: [
          {
            catalogueId: '308a5676-8e3f-4b1d-8948-a9aae1c641ab',
            catalogueName: 'CGL',
            description: 'string',
            imagePath: 'string',
            colour: 'string',
            student: false,
            internalStudent: false,
            features: false,
            subjectCount: 1,
            totalVideos: 2,
            totalHours: 0,
            subscriptions: [],
          },
          {
            catalogueId: '8fe6f296-a900-4114-b0c6-cf64c121160f',
            catalogueName: 'IES',
            description: 'string',
            imagePath: 'string',
            colour: 'string',
            student: false,
            internalStudent: false,
            features: false,
            subjectCount: 1,
            totalVideos: 2,
            totalHours: 800,
            subscriptions: [],
          },
        ],
      },
      {
        subCategoryId: 'e80bd1ad-8c45-4aec-8c49-572eae443eb3',
        subCategoryName: 'Test Subcategory2',
        catalogues: [
          {
            catalogueId: '7dfff89f-f229-44b8-a0b4-0cc641780894',
            catalogueName: 'CatalogLocal-111',
            description: 'This is the catalog testing in local',
            imagePath: 'https://d1k3nlqshgkoey.cloudfront.net/Card 2.png',
            colour: '228.225.128.#e4e180',
            student: false,
            internalStudent: false,
            features: false,
            subjectCount: 1,
            totalVideos: 20,
            totalHours: 0,
            subscriptions: [],
          },
        ],
      },
    ],
    publishState: false,
  },
  {
    categoryId: 'b763456e-42e1-4cff-afbc-e88c28e0469a',
    categoryName: 'Engineering',
    catalogues: [],
    subCategories: [
      {
        subCategoryId: '3a510654-15e6-46a8-836b-f8edf44a7e84',
        subCategoryName: 'ESE',
        catalogues: [
          {
            catalogueId: '3380956b-c9f6-440e-8318-8ded7d1e6005',
            catalogueName: 'ESE - General Studies and Engineering Aptitude(updated)',
            description:
              "This course is primarily aimed at Indian Engineering Services 2020 and 2021 aspirants and covers General Studies and Engineering Aptitude for IES prelims which includes in-depth coverage of Current Issues, Principles of Design, Ethics & Values, Information Communication Technology, Project Management, Energy & Environment, Numerical Ability, and Material science. Current Affairs subject is periodically updated to keep the course relevant and the student's examination and interview ready.(updated)",
            imagePath: 'https://d1k3nlqshgkoey.cloudfront.net/Card 2(updated).png',
            colour: '228.225.128.#e4e180(updated)',
            student: false,
            internalStudent: false,
            features: false,
            subjectCount: 2,
            totalVideos: 433,
            totalHours: 0,
            subscriptions: [],
          },
          {
            catalogueId: '52d6a443-4010-475d-bc9d-8f92b4403f1e',
            catalogueName: 'GATE',
            description:
              "This course is primarily aimed at Indian Engineering Services 2020 and 2021 aspirants and covers General Studies and Engineering Aptitude for IES prelims which includes in-depth coverage of Current Issues, Principles of Design, Ethics & Values, Information Communication Technology, Project Management, Energy & Environment, Numerical Ability, and Material science. Current Affairs subject is periodically updated to keep the course relevant and the student's examination and interview ready.",
            imagePath: 'https://d1k3nlqshgkoey.cloudfront.net/Card 2.png',
            colour: '228.225.128.#e4e180',
            student: true,
            internalStudent: true,
            features: true,
            subjectCount: 2,
            totalVideos: 433,
            totalHours: 100,
            subscriptions: [],
          },
          {
            catalogueId: '2d29e2ac-2013-4b01-a8fd-4903a70517d3',
            catalogueName: 'GATE',
            description:
              "This course is primarily aimed at Indian Engineering Services 2020 and 2021 aspirants and covers General Studies and Engineering Aptitude for IES prelims which includes in-depth coverage of Current Issues, Principles of Design, Ethics & Values, Information Communication Technology, Project Management, Energy & Environment, Numerical Ability, and Material science. Current Affairs subject is periodically updated to keep the course relevant and the student's examination and interview ready.",
            imagePath: 'https://d1k3nlqshgkoey.cloudfront.net/Card 2.png',
            colour: '228.225.128.#e4e180',
            student: true,
            internalStudent: true,
            features: true,
            subjectCount: 2,
            totalVideos: 433,
            totalHours: 100,
            subscriptions: [],
          },
          {
            catalogueId: '709b347d-cae9-4d5b-9106-449fe160cadc',
            catalogueName: 'ILETS',
            description:
              "This course is primarily aimed at Indian Engineering Services 2020 and 2021 aspirants and covers General Studies and Engineering Aptitude for IES prelims which includes in-depth coverage of Current Issues, Principles of Design, Ethics & Values, Information Communication Technology, Project Management, Energy & Environment, Numerical Ability, and Material science. Current Affairs subject is periodically updated to keep the course relevant and the student's examination and interview ready.",
            imagePath: 'https://d1k3nlqshgkoey.cloudfront.net/Card 2.png',
            colour: '228.225.128.#e4e180',
            student: true,
            internalStudent: true,
            features: true,
            subjectCount: 2,
            totalVideos: 433,
            totalHours: 100,
            subscriptions: [],
          },
          {
            catalogueId: 'd12e028c-9f24-4eec-8328-45ad89e8dfa0',
            catalogueName: 'ESE - General Studies and Engineering Aptitude-Changed',
            description:
              "This course is primarily aimed at Indian Engineering Services 2020 and 2021 aspirants and covers General Studies and Engineering Aptitude for IES prelims which includes in-depth coverage of Current Issues, Principles of Design, Ethics & Values, Information Communication Technology, Project Management, Energy & Environment, Numerical Ability, and Material science. Current Affairs subject is periodically updated to keep the course relevant and the student's examination and interview ready.",
            imagePath: 'https://d1k3nlqshgkoey.cloudfront.net/Card 2.png',
            colour: '228.225.128.#e4e180',
            student: true,
            internalStudent: true,
            features: true,
            subjectCount: 2,
            totalVideos: 433,
            totalHours: 100,
            subscriptions: [],
          },
          {
            catalogueId: 'abb0618a-ef34-4a65-8db7-4138a5f5832d',
            catalogueName: 'ESE Civil Engineering',
            description:
              "This course is primarily aimed at Indian Engineering Services 2020 and 2021 aspirants and covers General Studies and Numerical Ability for IES prelims which includes in-depth coverage of Current Issues, Principles of Design, Ethics & Values, Information Communication Technology, Project Management, Energy & Environment, Numerical Ability, and Material science. Current Affairs subject is periodically updated to keep the course relevant and the student's examination and interview ready.This course is primarily aimed at Indian Engineering Services 2020 and 2021 aspirants and covers General Studies and Numerical Ability for IES prelims which includes in-depth coverage of Current Issues, Principles of Design, Ethics & Values, Information Communication Technology, Project Management, Energy & Environment, Numerical Ability, and Material science. Current Affairs subject is periodically updated to keep the course relevant and the student's examination and interview ready.This course is primarily aimed at Indian Engineering Services 2020 and 2021 aspirants and covers General Studies and Numerical Ability for IES prelims which includes in-depth coverage of Current Issues, Principles of Design, Ethics & Values, Information Communication Technology, Project Management, Energy & Environment, Numerical Ability, and Material science. Current Affairs subject is periodically updated to keep the course relevant and the student's examination and interview ready.",
            imagePath: 'https://d1k3nlqshgkoey.cloudfront.net/Card 2.png',
            colour: '228.225.128.#e4e180',
            student: true,
            internalStudent: true,
            features: true,
            subjectCount: 2,
            totalVideos: 433,
            totalHours: 100,
            subscriptions: [],
          },
        ],
      },
    ],
    publishState: false,
  },
  {
    categoryId: '82f7596e-7509-4d7d-88b8-2c68d4be298b',
    categoryName: 'Category-12',
    catalogues: [],
    subCategories: [],
    publishState: false,
  },
  {
    categoryId: '959e402c-152e-4b8d-a600-c1bc9f01d0b2',
    categoryName: 'Category-1',
    catalogues: [],
    subCategories: [],
    publishState: true,
  },
]);
